import { get, patch } from '../../utils/http';

export const fetchCandidates = ({ accountId, ...params }) => get(`/accounts/${accountId}/candidates`, params);

export const patchCandidate = ({ accountId, requestId, isApproved }) =>
  patch(`/accounts/${accountId}/candidates/${requestId}`, { isApproved });
